
// Define currency symbol mappings with position
var currencySymbols = {
  "EUR": { symbol: "€", position: "before", separator: "," },      // Euro
  "DKK": { symbol: " kr", position: "after", separator: "," },     // Danish Krone
  "SEK": { symbol: " kr", position: "after", separator: "," },     // Swedish Krona
  "NOK": { symbol: " kr", position: "after", separator: "," },     // Norwegian Krone
  "GBP": { symbol: "£", position: "before", separator: "." },      // British Pound
  "CHF": { symbol: " CHF", position: "after", separator: "." },    // Swiss Franc
  "PLN": { symbol: " zł", position: "after", separator: "," },     // Polish Zloty
  "CZK": { symbol: " Kč", position: "after", separator: "," },     // Czech Koruna
  "HUF": { symbol: " Ft", position: "after", separator: "," },     // Hungarian Forint
  "RON": { symbol: " lei", position: "after", separator: "," },    // Romanian Leu
  "USD": { symbol: "$", position: "before", separator: "." },      // United States Dollar
  "AUD": { symbol: "A$", position: "before", separator: "." },     // Australian Dollar
  "CAD": { symbol: "C$", position: "before", separator: "." },     // Canadian Dollar
  "NZD": { symbol: "NZ$", position: "before", separator: "." }     // New Zealand Dollar
};

// Function to get the current currency in Shopify
function getCurrency() {
  // Check if Shopify and its currency property are available
  if (typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) {
    return Shopify.currency.active;
  }
  return "EUR"; // Default to EUR if currency is not set
}

// Function to format the price based on currency
function formatPrice(price) {
  // --- Cascade Comprehensive Debug ---
  console.log('--- Cascade Debug ---');
  console.log('Timestamp:', new Date().toISOString());
  console.log('Shopify Object:', typeof Shopify !== 'undefined' ? Shopify : 'Not Found');
  console.log('Shopify.country:', (typeof Shopify !== 'undefined' && Shopify.country) ? Shopify.country : 'Not Found');
  console.log('HTML Lang Attr:', document.documentElement.lang);
  console.log('Window Hostname:', window.location.hostname);
  console.log('--- End Debug ---');

  var currency = getCurrency();

  // Handle EUR with country-specific rules
  if (currency === 'EUR') {
    const eurCountriesWithSymbolAfter = ['DE', 'FR', 'ES', 'IT', 'PT', 'GR', 'FI', 'ET', 'LV', 'LT', 'SK', 'SL', 'HR'];
    const num = price.toFixed(2).replace('.', ',');
    const pathSeg = (window.location.pathname.split('/')[1] || '').toLowerCase().split('-')[0];
    const eurAfterLangs = ['de','fr','es','it','pt','el','fi','et','lv','lt','sk','sl','hr'];
    const eurBeforeLangs = ['nl','en'];
    // Get country code from the most reliable source available
    let countryCode = '';
    try {
      const klarnaData = JSON.parse(localStorage.getItem('klarna-osm-data'));
      if (klarnaData && klarnaData.storefrontCountry) {
        countryCode = klarnaData.storefrontCountry; // e.g., 'FR'
      }
    } catch (e) { /* Do nothing, fallback to other methods */ }

    if (!countryCode && typeof Shopify !== 'undefined' && Shopify.country) {
      countryCode = Shopify.country; // Fallback 1: Shopify object
    }

    if (!countryCode) {
      const pageLang = document.documentElement.lang || 'en'; // Fallback 2: HTML lang attr
      countryCode = pageLang.split('-')[0].toUpperCase();
    }

    let symbolAfter;
    if (eurAfterLangs.includes(pathSeg)) symbolAfter = true;
    else if (eurBeforeLangs.includes(pathSeg)) symbolAfter = false;
    else symbolAfter = eurCountriesWithSymbolAfter.includes(countryCode);
    if (symbolAfter) {
      return num + ' €';
    } else if (countryCode === 'IE') {
      return '€' + num;
    } else {
      return '€ ' + num;
    }
  }

  // Fallback to original JS logic for all other currencies
  var currencyInfo = currencySymbols[currency] || { symbol: currency + " ", position: "after", separator: "." }; // Fallback for unknown currencies
  var symbol = currencyInfo.symbol;
  var position = currencyInfo.position;
  var separator = currencyInfo.separator;
  var priceString = (typeof price === 'number') ? price.toFixed(2) : '0.00';
  var formattedPrice = priceString.replace('.', separator);

  return position === "before"
    ? symbol + formattedPrice
    : formattedPrice + symbol;
}

// This function updates the price and discount
function updatePriceAndDiscount(variant) {
  // Ensure variantPrices is defined and the variant exists
  if (typeof variantPrices === 'undefined' || !variantPrices[variant]) {
      console.error("variantPrices is not defined or variant not found:", variant);
      return;
  }

  var selectedVariantPrice = variantPrices[variant];
  var discountRate = 0; // Default to no discount

  if (document.querySelector('.promotion-block.special-discount')) {
    discountRate = 0.20;
  } else if (document.querySelector('.promotion-block.standard-discount')) {
    discountRate = 0.15;
  }

  var savingsEl = document.querySelector('.savings');
  var discountedPriceEl = document.querySelector('.discounted-price');

  if (!savingsEl) {
      console.error("Required DOM element (.savings) not found.");
      return;
  }

  if (discountRate > 0) {
    var discount_value = selectedVariantPrice * discountRate;
    var sales_price = selectedVariantPrice - discount_value;
    savingsEl.textContent = formatPrice(discount_value);
    if (discountedPriceEl) discountedPriceEl.textContent = "Discounted Price: " + formatPrice(sales_price);
    var voucherPriceEl = document.querySelector('[data-voucher-price]');
    var voucherSavingEl = document.querySelector('[data-voucher-saving]');
    if (voucherPriceEl) voucherPriceEl.textContent = formatPrice(sales_price);
    if (voucherSavingEl) voucherSavingEl.textContent = formatPrice(discount_value);
  } else {
    savingsEl.textContent = formatPrice(0);
    if (discountedPriceEl) discountedPriceEl.textContent = "Price: " + formatPrice(selectedVariantPrice);
  }
}

// Function to initialize the script
function initializePriceUpdater() {
  console.log('Price updater initialized.'); // Add log to confirm execution

    // Event listener setup for radio buttons
    var radios = document.querySelectorAll('.options-selection__option-value-input');
    if (radios.length === 0) {
        console.warn("No radio buttons with the class '.options-selection__option-value-input' found.");
        return;
    }

    radios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        var selectedOptions = document.querySelectorAll('.options-selection__option-value-input:checked');
        var variant = Array.from(selectedOptions).map(option => option.value).join(' / ');
        updatePriceAndDiscount(variant);
      });
    });

    document.addEventListener('variant-change', function(e) {
      if (e.detail && e.detail.variant && e.detail.variant.title) {
        updatePriceAndDiscount(e.detail.variant.title);
      }
    }, true);

    var voucher = document.querySelector('[data-voucher]');
    if (voucher) {
      var voucherCheck = voucher.querySelector('[data-voucher-check]');
      if (voucherCheck) {
        voucherCheck.addEventListener('change', function() {
          if (voucherCheck.checked) {
            var code = voucher.getAttribute('data-voucher-code');
            if (code) {
              fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function() {});
            }
          }
        });
      }
    }

    // Initial update for the currently selected variant on page load
    var currentVariant = Array.from(document.querySelectorAll('.options-selection__option-value-input:checked')).map(option => option.value).join(' / ');
    if (currentVariant) {
        updatePriceAndDiscount(currentVariant);
    }
}

// Wait for the variantPrices object to be defined before initializing
document.addEventListener('DOMContentLoaded', function() {
  var interval = setInterval(function() {
    if (typeof variantPrices !== 'undefined' && Object.keys(variantPrices).length > 0) {
      clearInterval(interval); // Stop polling
      initializePriceUpdater();
    }
  }, 100); // Check every 100ms
});